import React, { useEffect, useRef, useState } from 'react';
import Header from '../../layouts/Header';
import { Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import ReusableTable from '../../components/ReusableTable';
import axiosInstance from '../../api/axios'; import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import Select from "react-select";

/* ─────────────────────────────────────────────────────────────
   STYLES
───────────────────────────────────────────────────────────── */
const styles = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600&family=Syne:wght@600;700;800&display=swap');

.ku-root {
  min-height: 100vh;
  padding: 22px 24px 40px;
}

/* ── PAGE HEADER ── */
.ku-page-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 12px;
  flex-wrap: wrap;
}

.ku-title {
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
  letter-spacing: -0.4px;
}

.ku-sub {
  font-size: 11.5px;
  color: #999;
  margin: 3px 0 0;
}

/* ── OUTLET CARDS ── */
.ku-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
  margin-bottom: 24px;
  align-items: start;
}

/* Full-width slot injected after the active row */
.ku-row-panel-slot {
  grid-column: 1 / -1;
  margin-top: 4px;
  animation: kuSlideDown 0.25s cubic-bezier(.4,0,.2,1);
}

@keyframes kuSlideDown {
  from { opacity: 0; transform: translateY(-8px); }
  to   { opacity: 1; transform: translateY(0); }
}

.ku-card {
  background: #fff;
  border-radius: 14px;
  padding: 16px 15px 13px;
  cursor: pointer;
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
  transition: all 0.2s cubic-bezier(.4,0,.2,1);
  box-shadow: 0 1px 6px rgba(0,0,0,0.05);
}

.ku-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 3px;
  background: linear-gradient(90deg, #0f766e, #0891b2);
  opacity: 0;
  transition: opacity 0.2s;
}

.ku-card:hover { border-color: #ccfbf1; box-shadow: 0 6px 22px rgba(15,118,110,0.10); transform: translateY(-2px); }
.ku-card:hover::before { opacity: 1; }
.ku-card.active { border-color: #0f766e; box-shadow: 0 6px 24px rgba(15,118,110,0.16); transform: translateY(-2px); }
.ku-card.active::before { opacity: 1; }

.ku-card-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: linear-gradient(135deg, #ccfbf1, #cffafe);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  margin-bottom: 10px;
}

.ku-card-name {
  font-size: 13px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ku-card-loc {
  font-size: 10.5px;
  color: #bbb;
  margin: 0 0 10px;
}

.ku-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ku-pill {
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.4px;
  padding: 2px 8px;
  border-radius: 20px;
  text-transform: uppercase;
}

.ku-pill-active   { background: #dcfce7; color: #16a34a; }
.ku-pill-inactive { background: #fee2e2; color: #dc2626; }
.ku-pill-soon     { background: #fef3c7; color: #d97706; }

.ku-card-arrow {
  width: 24px;
  height: 24px;
  border-radius: 7px;
  background: #f0fdf9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0f766e;
  font-size: 13px;
  transition: background 0.15s, transform 0.22s;
}

.ku-card.active .ku-card-arrow {
  background: #0f766e;
  color: #fff;
  transform: rotate(90deg);
}

/* ── USERS PANEL ── */
.ku-panel {
  background: #fff;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(0,0,0,0.07);
  border: 1.5px solid #ccfbf1;
}

.ku-panel-header {
  padding: 15px 20px;
  border-bottom: 1px solid #f0f0ee;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

.ku-panel-title {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ku-count-badge {
  font-size: 10.5px;
  font-weight: 600;
  background: #ccfbf1;
  color: #0f766e;
  border-radius: 20px;
  padding: 2px 10px;
}

.ku-panel-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ku-search {
  position: relative;
}

.ku-search input {
  background: #f8f8f6;
  border: 1.5px solid #ebebeb;
  border-radius: 9px;
  padding: 6px 10px 6px 32px;
  font-size: 12px;
  color: #1a1a1a;
  outline: none;
  width: 200px;
  transition: border-color 0.15s;
}

.ku-search input:focus { border-color: #0f766e; }
.ku-search i { position: absolute; left: 9px; top: 50%; transform: translateY(-50%); color: #bbb; font-size: 13px; }

.ku-add-btn {
  background: linear-gradient(135deg, #0f766e, #0891b2);
  color: #fff;
  border: none;
  border-radius: 9px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  transition: opacity 0.15s, transform 0.12s;
  white-space: nowrap;
}

.ku-add-btn:hover { opacity: 0.88; transform: translateY(-1px); }

/* Table */
.ku-panel .table { font-size: 12.5px; margin: 0; }
.ku-panel .table th {
  background: #fafaf8;
  color: #999;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  border-bottom: 1px solid #f0f0ee;
  padding: 10px 14px;
}
.ku-panel .table td { padding: 11px 14px; vertical-align: middle; border-bottom: 1px solid #f8f8f6; }
.ku-panel .table tbody tr:last-child td { border-bottom: none; }
.ku-panel .table tbody tr:hover td { background: #f0fdf9; }

/* Empty & Skeleton */
.ku-empty { text-align: center; padding: 52px 20px; color: #ccc; }
.ku-empty i { font-size: 44px; display: block; margin-bottom: 10px; opacity: 0.3; }
.ku-empty p { font-size: 12.5px; margin: 0; }

.ku-skeleton {
  background: linear-gradient(90deg, #f0f0ec 25%, #e8e8e4 50%, #f0f0ec 75%);
  background-size: 200% 100%;
  animation: ku-shimmer 1.4s infinite;
  border-radius: 7px;
  height: 13px;
}

@keyframes ku-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ── MODALS ── */
.ku-modal .modal-content {
  border: none;
  border-radius: 16px;
  font-size: 13px;
  box-shadow: 0 20px 56px rgba(0,0,0,0.13);
}

.ku-modal .modal-header {
  border-bottom: 1px solid #f0f0ee;
  padding: 14px 20px;
  background: #fafaf8;
  border-radius: 16px 16px 0 0;
}

.ku-modal .modal-title {
  font-size: 15px;
  font-weight: 700;
}

.ku-modal .modal-footer {
  border-top: 1px solid #f0f0ee;
  background: #fafaf8;
  border-radius: 0 0 16px 16px;
  padding: 11px 20px;
}

.ku-modal .form-label {
  font-size: 11px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  margin-bottom: 4px;
}

.ku-modal .form-control {
  font-size: 12.5px;
  border-radius: 8px;
  border: 1.5px solid #e8e8e4;
  background: #fafaf7;
}

.ku-modal .form-control:focus {
  border-color: #0f766e;
  box-shadow: 0 0 0 3px rgba(15,118,110,0.08);
}

.ku-modal-btn {
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  padding: 7px 18px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  transition: opacity 0.15s;
}

.ku-modal-btn:hover { opacity: 0.88; }
.ku-modal-btn-primary { background: linear-gradient(135deg, #0f766e, #0891b2); color: #fff; }
.ku-modal-btn-secondary { background: #f0f0ec; color: #555; }
.ku-modal-btn-danger { background: #dc2626; color: #fff; }
`;

/* ─────────────────────────────────────────────────────────────
   INLINE PANEL COMPONENT
───────────────────────────────────────────────────────────── */
const InlineUsersPanel = ({
    selectedOutlet,
    filteredData,
    dataLoading,
    searchText,
    setSearchText,
    hasPerm,
    columns,
    getPaginatedData,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    setUserInputData,
    setErrors,
    setOpenAddModal,
    panelRef,
}) => (
    <div className="ku-panel" ref={panelRef}>
        <div className="ku-panel-header">
            <h2 className="ku-panel-title">
                <i className="ri-computer-line" style={{ color: "#0f766e" }}></i>
                {selectedOutlet.name}
                <span className="ku-count-badge">{filteredData.length} users</span>
            </h2>
            <div className="ku-panel-controls">
                <div className="ku-search">
                    <i className="ri-search-line"></i>
                    <input
                        type="text"
                        placeholder="Search users..."
                        value={searchText}
                        onChange={e => setSearchText(e.target.value)}
                    />
                </div>
                {hasPerm("add") && (
                    <button
                        className="ku-add-btn"
                        onClick={() => {
                            setUserInputData({
                                name: "",
                                signupType: "",
                                mobile: "",
                                email: "",
                                outlet: selectedOutlet._id,
                                password: "",
                            });
                            setErrors({});
                            setOpenAddModal(true);
                        }}
                    >
                        <i className="ri-add-line"></i> Add User
                    </button>
                )}
            </div>
        </div>

        {dataLoading ? (
            <div style={{ padding: "32px 20px" }}>
                {[1, 2, 3].map(i => (
                    <div key={i} className="d-flex gap-3 mb-3">
                        <div style={{ flex: 1 }}>
                            <div className="ku-skeleton" style={{ width: "55%", marginBottom: 8 }}></div>
                            <div className="ku-skeleton" style={{ width: "38%", height: 10 }}></div>
                        </div>
                        <div className="ku-skeleton" style={{ width: 70, height: 20, borderRadius: 20 }}></div>
                    </div>
                ))}
            </div>
        ) : filteredData.length === 0 ? (
            <div className="ku-empty">
                <i className="ri-user-line"></i>
                <p>No kiosk users found for <strong>{selectedOutlet.name}</strong></p>
            </div>
        ) : hasPerm("get") ? (
            <ReusableTable
                columns={columns}
                data={getPaginatedData()}
                rowKey="serialNumber"
                loading={false}
                currentPage={page}
                recordsPerPage={rowsPerPage}
                onPageChange={setPage}
                totalPages={Math.ceil(filteredData.length / rowsPerPage)}
                onRecordsPerPageChange={(r) => { setPage(1); setRowsPerPage(r); }}
            />
        ) : (
            <div className="ku-empty">
                <i className="ri-lock-line"></i>
                <p>You don't have permission to view users</p>
            </div>
        )}
    </div>
);

/* ─────────────────────────────────────────────────────────────
   MAIN COMPONENT
───────────────────────────────────────────────────────────── */
const KioskOutletUsers = () => {
    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);
    
    // const { access, email } = useSelector((state) => state.login);

    const { access } = useSelector((state) => state.login);
    const { loginEmail } = useSelector((state) => state.login);
    const email = loginEmail || localStorage.getItem("email");

    const [outletAccess, setOutletAccess] = useState([]);
    const accessToken = localStorage.getItem('authToken');

    // Data
    const [outletUserList, setOutletUserList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [outletsList, setOutletsList] = useState([]);
    const [outletsLoading, setOutletsLoading] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);

    // Selection & search
    const [selectedOutlet, setSelectedOutlet] = useState(null);
    const [activeIndex, setActiveIndex] = useState(null);
    const [searchText, setSearchText] = useState('');

    // Cards-per-row (measured from DOM, same as OutletUsers)
    const [cardsPerRow, setCardsPerRow] = useState(5);

    // Pagination
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    // Modals
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [kioskUserId, setKioskUserId] = useState('');

    // Form data
    const [userInputData, setUserInputData] = useState({ name: "", signupType: "", mobile: "", email: "", outlet: "", password: "" });
    const [editedUserData, setEditedUserData] = useState({});
    const [errors, setErrors] = useState({});
    const [editErrors, setEditErrors] = useState({});

    // Loading
    const [isAddBtnLoading, setIsAddBtnLoading] = useState(false);
    const [isEditBtnLoading, setIsEditBtnLoading] = useState(false);
    const [isDeleteBtnLoading, setIsDeleteBtnLoading] = useState(false);

    const gridRef = useRef(null);
    const panelRef = useRef(null);

    /* ── Permissions ── */
    useEffect(() => {
        if (Array.isArray(access)) {
            setOutletAccess(access.filter(p => p?.startsWith("KioskUser:")));
        }
    }, [access]);

    const hasPerm = (action) =>
        outletAccess.includes(`KioskUser:${action}`) || email === 'contact@xpansecafe.com';

    const getStatusClass = (s) => s === "ACTIVE" ? "active" : s === "COMING_SOON" ? "soon" : "inactive";

    /* ── Measure cards-per-row (same strategy as OutletUsers) ── */
    useEffect(() => {
        const measure = () => {
            if (!gridRef.current) return;
            const gridStyle = window.getComputedStyle(gridRef.current);
            const cols = gridStyle.gridTemplateColumns.split(' ').filter(Boolean).length;
            setCardsPerRow(cols || 1);
        };
        measure();
        window.addEventListener('resize', measure);
        return () => window.removeEventListener('resize', measure);
    }, [outletsList, outletsLoading]);

    useEffect(() => {
        if (!outletsLoading && outletsList.length > 0) {
            setTimeout(() => {
                if (!gridRef.current) return;
                const gridStyle = window.getComputedStyle(gridRef.current);
                const cols = gridStyle.gridTemplateColumns.split(' ').filter(Boolean).length;
                setCardsPerRow(cols || 1);
            }, 50);
        }
    }, [outletsLoading, outletsList]);

    /* ── Scroll panel into view after render ── */
    useEffect(() => {
        if (panelRef.current) {
            panelRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
    }, [selectedOutlet]);

    /* ── API ── */
    const getKioskOutletUsers = async (outletId) => {
        if (!outletId) return;
        setDataLoading(true);
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const res = await axiosInstance.get(`user/kiosk-outlet-user?outlet=${outletId}`, { headers });
            const users = (res?.data?.data?.kioskOutletUsers || []).map((u, i) => ({ ...u, serialNumber: i + 1 }));
            setOutletUserList(users);
            setFilteredData(users);
        } catch (err) {
            if (err.response?.data?.status === false)
                toast.error(err.response.data.error, { position: "top-right", autoClose: 3000 });
        } finally {
            setDataLoading(false);
        }
    };

    const getOutletsData = async () => {
        setOutletsLoading(true);
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const res = await axiosInstance.get("outlet", { headers });
            setOutletsList(res?.data?.data?.outlets || []);
        } catch (err) {
            if (err.response?.data?.status === false)
                toast.error(err.response.data.error, { position: "top-right", autoClose: 3000 });
        } finally {
            setOutletsLoading(false);
        }
    };

    /* ── Card click ── */
    const handleCardClick = (outlet, index) => {
        if (selectedOutlet?._id === outlet._id) {
            setSelectedOutlet(null);
            setActiveIndex(null);
            setOutletUserList([]);
            setFilteredData([]);
            return;
        }
        setSelectedOutlet(outlet);
        setActiveIndex(index);
        setSearchText('');
        setPage(1);
        getKioskOutletUsers(outlet._id);
    };

    /* ── Validation ── */
    const specialChar = /[!@#$%^&*(),.?":{}|<>]/;

    const validateAdd = () => {
        const e = {};
        const name = userInputData.name?.trim();
        if (!name) e.name = "Name is required";
        else if (!isNaN(name)) e.name = "Name cannot be numeric";
        else if (name.length < 2) e.name = "Min 2 characters";
        else if (specialChar.test(name)) e.name = "No special characters";

        if (!userInputData.email) e.email = "Email is required";
        const mob = userInputData.mobile?.trim();
        if (!mob) e.mobile = "Mobile is required";
        else if (mob.length !== 10) e.mobile = "Must be 10 digits";
        else if (specialChar.test(mob)) e.mobile = "No special characters";
        if (!userInputData.outlet) e.outlet = "Outlet is required";
        if (!userInputData.password) e.password = "Password is required";
        else if (userInputData.password.length < 5) e.password = "Min 5 characters";
        if (!userInputData.signupType) e.signupType = "Signup type is required";
        setErrors(e);
        return Object.keys(e).length === 0;
    };

    const validateEdit = () => {
        const e = {};
        const name = editedUserData.name?.trim();
        if (!name) e.name = "Name is required";
        else if (!isNaN(name)) e.name = "Name cannot be numeric";
        else if (name.length < 2) e.name = "Min 2 characters";
        else if (specialChar.test(name)) e.name = "No special characters";
        if (!editedUserData.email) e.email = "Email is required";
        const mob = editedUserData.mobile?.trim();
        if (!mob) e.mobile = "Mobile is required";
        else if (mob.length !== 10) e.mobile = "Must be 10 digits";
        setEditErrors(e);
        return Object.keys(e).length === 0;
    };

    /* ── Form handlers ── */
    const handleChange = (e) => {
        const { name, value } = e.target;
        setUserInputData(p => ({ ...p, [name]: value }));
        setErrors(p => ({ ...p, [name]: "" }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateAdd()) return;
        setIsAddBtnLoading(true);
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const res = await axiosInstance.post("auth/user/create-outlet-user-account", userInputData, { headers });
            if (res?.data?.status) {
                toast.success(res.data.data.message, { position: "top-right", autoClose: 3000 });
                getKioskOutletUsers(selectedOutlet?._id);
                setUserInputData({ name: "", signupType: "", mobile: "", email: "", outlet: selectedOutlet?._id || "", password: "" });
                setOpenAddModal(false);
            }
        } catch (err) {
            const msg = err?.response?.data?.error?.message || err?.response?.data?.error || "Something went wrong";
            toast.error(msg, { position: "top-right", autoClose: 3000 });
        } finally {
            setIsAddBtnLoading(false);
        }
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        if (!validateEdit()) return;
        setIsEditBtnLoading(true);
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const res = await axiosInstance.put("user/kiosk-outlet-user/profile", editedUserData, { headers });
            if (res?.data?.status) {
                toast.success(res.data.data.message, { position: "top-right", autoClose: 3000 });
                getKioskOutletUsers(selectedOutlet?._id);
                setOpenEditModal(false);
            }
        } catch (err) {
            const msg = err?.response?.data?.error?.message || err?.response?.data?.error || "Something went wrong";
            toast.error(msg, { position: "top-right", autoClose: 3000 });
        } finally {
            setIsEditBtnLoading(false);
        }
    };

    const handleDeleteKioskUser = async (e) => {
        e.preventDefault();
        setIsDeleteBtnLoading(true);
        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const res = await axiosInstance.delete("user/kiosk-outlet-user", { data: { _id: kioskUserId }, headers });
            if (res?.data?.status) {
                toast.success(res.data.data.message, { position: "top-right", autoClose: 3000 });
                getKioskOutletUsers(selectedOutlet?._id);
                setOpenDeleteModal(false);
            }
        } catch (err) {
            const msg = err?.response?.data?.error || err?.response?.data?.message || "Error";
            toast.error(msg, { position: "top-right", autoClose: 3000 });
        } finally {
            setIsDeleteBtnLoading(false);
        }
    };

    /* ── Search ── */
    useEffect(() => {
        if (!searchText.trim()) { setFilteredData(outletUserList); return; }
        const re = new RegExp(searchText, "i");
        setFilteredData(outletUserList.filter(u =>
            u.name?.match(re) || u.email?.match(re) || u.mobile?.includes(searchText)
        ));
        setPage(1);
    }, [searchText, outletUserList]);

    const getPaginatedData = () => {
        const s = (page - 1) * rowsPerPage;
        return filteredData.slice(s, s + rowsPerPage);
    };

    useEffect(() => { getOutletsData(); }, []);

    const signupTypeOptions = [{ value: "REGULAR", label: "Regular" }];

    /* ── Table columns ── */
    const columns = [
        { header: "Sr.", accessor: "serialNumber", width: "50px" },
        {
            header: "User",
            accessor: "name",
            render: (value, row) => (
                <div>
                    <div style={{ fontSize: 12.5, fontWeight: 600 }}>{value}</div>
                    <div style={{ fontSize: 11, color: "#aaa" }}>{row.email}</div>
                </div>
            ),
        },
        {
            header: "Mobile",
            accessor: "mobile",
            render: (value) => <span style={{ fontSize: 12, color: "#0f766e", fontWeight: 500 }}>{value}</span>
        },
        {
            header: "Signup Type",
            accessor: "signupType",
            render: (value) => (
                <span style={{ fontSize: 10.5, fontWeight: 600, background: "#cffafe", color: "#0891b2", borderRadius: 20, padding: "2px 10px" }}>
                    {value}
                </span>
            )
        },
        {
            header: "Actions",
            accessor: null,
            width: "70px",
            render: (_, row) => (
                <div className="d-flex justify-content-center gap-1">
                    {hasPerm("update") && (
                        <button
                            title="Edit"
                            style={{ width: 28, height: 28, borderRadius: 7, border: "none", background: "#f0f0ec", color: "#555", cursor: "pointer", fontSize: 13, display: "flex", alignItems: "center", justifyContent: "center", transition: "background 0.12s" }}
                            onMouseEnter={e => { e.currentTarget.style.background = "#dbeafe"; e.currentTarget.style.color = "#2563eb"; }}
                            onMouseLeave={e => { e.currentTarget.style.background = "#f0f0ec"; e.currentTarget.style.color = "#555"; }}
                            onClick={() => {
                                setEditedUserData({ _id: row._id, name: row.name, mobile: row.mobile, email: row.email });
                                setOpenEditModal(true);
                                setEditErrors({});
                            }}
                        >
                            <i className="ri-edit-line"></i>
                        </button>
                    )}
                    {hasPerm("delete") && (
                        <button
                            title="Delete"
                            style={{ width: 28, height: 28, borderRadius: 7, border: "none", background: "#f0f0ec", color: "#555", cursor: "pointer", fontSize: 13, display: "flex", alignItems: "center", justifyContent: "center", transition: "background 0.12s" }}
                            onMouseEnter={e => { e.currentTarget.style.background = "#fee2e2"; e.currentTarget.style.color = "#dc2626"; }}
                            onMouseLeave={e => { e.currentTarget.style.background = "#f0f0ec"; e.currentTarget.style.color = "#555"; }}
                            onClick={() => { setKioskUserId(row._id); setOpenDeleteModal(true); }}
                        >
                            <i className="ri-delete-bin-line"></i>
                        </button>
                    )}
                </div>
            ),
        },
    ];

    /* ── Build interleaved grid items (same strategy as OutletUsers) ──
     *
     * After the last card of the active row, inject a full-width slot
     * (grid-column: 1 / -1) containing the users panel.
     *
     * lastIndexInRow = min(activeIndex + cardsPerRow - (activeIndex % cardsPerRow), outlets.length) - 1
     */
    const buildGridItems = () => {
        if (activeIndex === null || !selectedOutlet) {
            return outletsList.map((outlet, i) => (
                <div
                    key={outlet._id}
                    className={`ku-card ${selectedOutlet?._id === outlet._id ? "active" : ""}`}
                    onClick={() => handleCardClick(outlet, i)}
                >
                    <div className="ku-card-icon">🖥️</div>
                    <p className="ku-card-name" title={outlet.name}>{outlet.name}</p>
                    <p className="ku-card-loc">{outlet.city || "—"}{outlet.state ? `, ${outlet.state}` : ""}</p>
                    <div className="ku-card-footer">
                        <span className={`ku-pill ku-pill-${getStatusClass(outlet.status)}`}>{outlet.status}</span>
                        <div className="ku-card-arrow">
                            <i className="ri-arrow-right-line"></i>
                        </div>
                    </div>
                </div>
            ));
        }

        const col = activeIndex % cardsPerRow;
        const rowEnd = activeIndex + (cardsPerRow - col);
        const insertAfter = Math.min(rowEnd, outletsList.length) - 1;

        const items = [];
        outletsList.forEach((outlet, i) => {
            items.push(
                <div
                    key={outlet._id}
                    className={`ku-card ${selectedOutlet?._id === outlet._id ? "active" : ""}`}
                    onClick={() => handleCardClick(outlet, i)}
                >
                    <div className="ku-card-icon">🖥️</div>
                    <p className="ku-card-name" title={outlet.name}>{outlet.name}</p>
                    <p className="ku-card-loc">{outlet.city || "—"}{outlet.state ? `, ${outlet.state}` : ""}</p>
                    <div className="ku-card-footer">
                        <span className={`ku-pill ku-pill-${getStatusClass(outlet.status)}`}>{outlet.status}</span>
                        <div className="ku-card-arrow">
                            <i className="ri-arrow-right-line"></i>
                        </div>
                    </div>
                </div>
            );

            // After the last card in the active row → inject the panel slot
            if (i === insertAfter) {
                items.push(
                    <div key="__ku_panel_slot__" className="ku-row-panel-slot">
                        <InlineUsersPanel
                            selectedOutlet={selectedOutlet}
                            filteredData={filteredData}
                            dataLoading={dataLoading}
                            searchText={searchText}
                            setSearchText={setSearchText}
                            hasPerm={hasPerm}
                            columns={columns}
                            getPaginatedData={getPaginatedData}
                            page={page}
                            setPage={setPage}
                            rowsPerPage={rowsPerPage}
                            setRowsPerPage={setRowsPerPage}
                            setUserInputData={setUserInputData}
                            setErrors={setErrors}
                            setOpenAddModal={setOpenAddModal}
                            panelRef={panelRef}
                        />
                    </div>
                );
            }
        });

        return items;
    };

    /* ── RENDER ── */
    return (
        <React.Fragment>
            <style>{styles}</style>
            <Header onSkin={setSkin} />
            <div className="main main-app ku-root">

                {/* Page Header */}
                <div className="ku-page-header">
                    <div>
                        <h3 className="ku-title">KIOSK OUTLET USERS</h3>
                        <p className="ku-sub">Select an outlet to manage its kiosk users</p>
                    </div>
                </div>

                {/* ── OUTLET CARDS ── */}
                {outletsLoading ? (
                    <div className="ku-cards-grid">
                        {[1, 2, 3, 4, 5, 6].map(i => (
                            <div key={i} className="ku-card" style={{ cursor: "default" }}>
                                <div className="ku-skeleton" style={{ width: 38, height: 38, borderRadius: 10, marginBottom: 10 }}></div>
                                <div className="ku-skeleton" style={{ width: "72%", marginBottom: 7 }}></div>
                                <div className="ku-skeleton" style={{ width: "48%", height: 10 }}></div>
                            </div>
                        ))}
                    </div>
                ) : outletsList.length === 0 ? (
                    <div className="ku-empty">
                        <i className="ri-store-2-line"></i>
                        <p>No outlets found</p>
                    </div>
                ) : (
                    <div className="ku-cards-grid" ref={gridRef}>
                        {buildGridItems()}
                    </div>
                )}

                {/* ── HINT when nothing selected ── */}
                {!selectedOutlet && !outletsLoading && outletsList.length > 0 && (
                    <div style={{ textAlign: "center", marginTop: 40, color: "#ccc" }}>
                        <i className="ri-computer-line" style={{ fontSize: 48, display: "block", marginBottom: 10, opacity: 0.25 }}></i>
                        <p style={{ fontSize: 12.5 }}>Click an outlet card to view its kiosk users</p>
                    </div>
                )}

                {/* ════════════════════
                    MODALS
                ════════════════════ */}

                {/* Add Modal */}
                <Modal dialogClassName="ku-modal" show={openAddModal} onHide={() => { setOpenAddModal(false); setErrors({}); }} centered size="md">
                    <Modal.Header closeButton>
                        <Modal.Title>Add Kiosk User — {selectedOutlet?.name}</Modal.Title>
                    </Modal.Header>
                    <Form onSubmit={handleSubmit}>
                        <Modal.Body style={{ padding: "16px 22px" }}>
                            <Row className="g-3">
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Name <span className="text-danger">*</span></Form.Label>
                                        <Form.Control type="text" name="name" size="sm" placeholder="Full name" value={userInputData.name} onChange={handleChange} />
                                        {errors.name && <div style={{ fontSize: 10.5, color: "#dc2626", marginTop: 3 }}>{errors.name}</div>}
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Email <span className="text-danger">*</span></Form.Label>
                                        <Form.Control type="email" name="email" size="sm" placeholder="Email address" value={userInputData.email} onChange={handleChange} />
                                        {errors.email && <div style={{ fontSize: 10.5, color: "#dc2626", marginTop: 3 }}>{errors.email}</div>}
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Mobile <span className="text-danger">*</span></Form.Label>
                                        <Form.Control type="tel" name="mobile" size="sm" placeholder="10-digit number" value={userInputData.mobile} onChange={handleChange} maxLength={10} />
                                        {errors.mobile && <div style={{ fontSize: 10.5, color: "#dc2626", marginTop: 3 }}>{errors.mobile}</div>}
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Password <span className="text-danger">*</span></Form.Label>
                                        <Form.Control type="password" name="password" size="sm" placeholder="Min 5 characters" value={userInputData.password} onChange={handleChange} />
                                        {errors.password && <div style={{ fontSize: 10.5, color: "#dc2626", marginTop: 3 }}>{errors.password}</div>}
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Outlet <span className="text-danger">*</span></Form.Label>
                                        <Select
                                            options={outletsList.map(o => ({ value: o._id, label: o.name }))}
                                            value={outletsList.find(o => o._id === userInputData.outlet) ? { value: userInputData.outlet, label: outletsList.find(o => o._id === userInputData.outlet)?.name } : null}
                                            onChange={sel => { setUserInputData(p => ({ ...p, outlet: sel?.value || "" })); setErrors(p => ({ ...p, outlet: "" })); }}
                                            placeholder="Select outlet"
                                            styles={{ control: base => ({ ...base, minHeight: 32, fontSize: 12.5, borderRadius: 8, border: "1.5px solid #e8e8e4" }) }}
                                        />
                                        {errors.outlet && <div style={{ fontSize: 10.5, color: "#dc2626", marginTop: 3 }}>{errors.outlet}</div>}
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Signup Type <span className="text-danger">*</span></Form.Label>
                                        <Select
                                            options={signupTypeOptions}
                                            value={signupTypeOptions.find(o => o.value === userInputData.signupType) || null}
                                            onChange={sel => { setUserInputData(p => ({ ...p, signupType: sel?.value || "" })); setErrors(p => ({ ...p, signupType: "" })); }}
                                            placeholder="Select type"
                                            styles={{ control: base => ({ ...base, minHeight: 32, fontSize: 12.5, borderRadius: 8, border: "1.5px solid #e8e8e4" }) }}
                                        />
                                        {errors.signupType && <div style={{ fontSize: 10.5, color: "#dc2626", marginTop: 3 }}>{errors.signupType}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" className="ku-modal-btn ku-modal-btn-secondary" onClick={() => { setOpenAddModal(false); setErrors({}); }}>Cancel</button>
                            <button type="submit" className="ku-modal-btn ku-modal-btn-primary" disabled={isAddBtnLoading}>
                                {isAddBtnLoading ? <Spinner size="sm" /> : "Add User"}
                            </button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* Edit Modal */}
                <Modal dialogClassName="ku-modal" show={openEditModal} onHide={() => { setOpenEditModal(false); setEditErrors({}); }} centered size="sm">
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Kiosk User</Modal.Title>
                    </Modal.Header>
                    <Form onSubmit={handleEditSubmit}>
                        <Modal.Body style={{ padding: "16px 22px" }}>
                            <Row className="g-3">
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label>Name <span className="text-danger">*</span></Form.Label>
                                        <Form.Control type="text" name="name" size="sm" value={editedUserData.name || ""} onChange={e => { setEditedUserData(p => ({ ...p, name: e.target.value })); setEditErrors(p => ({ ...p, name: "" })); }} />
                                        {editErrors.name && <div style={{ fontSize: 10.5, color: "#dc2626", marginTop: 3 }}>{editErrors.name}</div>}
                                    </Form.Group>
                                </Col>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label>Mobile <span className="text-danger">*</span></Form.Label>
                                        <Form.Control type="tel" name="mobile" size="sm" maxLength={10} value={editedUserData.mobile || ""} onChange={e => { setEditedUserData(p => ({ ...p, mobile: e.target.value })); setEditErrors(p => ({ ...p, mobile: "" })); }} />
                                        {editErrors.mobile && <div style={{ fontSize: 10.5, color: "#dc2626", marginTop: 3 }}>{editErrors.mobile}</div>}
                                    </Form.Group>
                                </Col>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label>Email <span className="text-danger">*</span></Form.Label>
                                        <Form.Control type="email" name="email" size="sm" value={editedUserData.email || ""} onChange={e => { setEditedUserData(p => ({ ...p, email: e.target.value })); setEditErrors(p => ({ ...p, email: "" })); }} />
                                        {editErrors.email && <div style={{ fontSize: 10.5, color: "#dc2626", marginTop: 3 }}>{editErrors.email}</div>}
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" className="ku-modal-btn ku-modal-btn-secondary" onClick={() => { setOpenEditModal(false); setEditErrors({}); }}>Cancel</button>
                            <button type="submit" className="ku-modal-btn ku-modal-btn-primary" disabled={isEditBtnLoading}>
                                {isEditBtnLoading ? "Saving..." : "Save Changes"}
                            </button>
                        </Modal.Footer>
                    </Form>
                </Modal>

                {/* Delete Modal */}
                <Modal dialogClassName="ku-modal" show={openDeleteModal} onHide={() => setOpenDeleteModal(false)} centered size="sm">
                    <Modal.Header closeButton>
                        <Modal.Title>Remove Kiosk User</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={{ padding: "20px 22px", textAlign: "center", fontSize: 13 }}>
                        <i className="ri-error-warning-line" style={{ fontSize: 38, color: "#dc2626", display: "block", marginBottom: 10 }}></i>
                        Are you sure you want to delete this kiosk user? This action <strong>cannot be undone</strong>.
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="ku-modal-btn ku-modal-btn-secondary" onClick={() => setOpenDeleteModal(false)}>Cancel</button>
                        <button type="button" className="ku-modal-btn ku-modal-btn-danger" onClick={handleDeleteKioskUser} disabled={isDeleteBtnLoading}>
                            {isDeleteBtnLoading ? <Spinner size="sm" /> : "Delete"}
                        </button>
                    </Modal.Footer>
                </Modal>

            </div>
        </React.Fragment>
    );
};

export default KioskOutletUsers;